import React from 'react';

import { WarehouseDetail } from 'components/blocks/Warehouse';

const DetailScreen = (props) => {
  return (
    <div className="page-main">
      <WarehouseDetail />
    </div>
  );
};

export default DetailScreen;
